<template>
  <div>
    <div>
      <div>Région</div>
      <el-select
         v-model="region"
         :filterable="true"
         ref="region"
         placeholder="- Toutes -"
         value-key="id"
         :clearable="true"
         @change="changeRegion" >
        <el-option v-for="region in regions" :key="region.id" :value="region" :label="region.name" />
      </el-select>
    </div>
    <div v-if="region" >
      <div>Département</div>
      <el-select
         v-model="department"
         :filterable="true"
         placeholder="- Tous -"
         value-key="id"
         :clearable="true"
         @change="changeDepartment" >
        <el-option
           v-for="department in departments"
           :key="department.id"
           :value="department"
           :label="department.name" />
      </el-select>
    </div>
    <div>
      <div>Zone d'emploi</div>
      <el-select
         v-model="employmentZone"
         :filterable="true"
         placeholder="- Toutes -"
         value-key="id"
         :clearable="true"
         @change="changeEmploymentZone"  >
        <el-option
           v-for="employmentZone in employmentZones"
           :key="employmentZone.id"
           :value="employmentZone"
           :label="employmentZone.name" />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    geoApi: {
      type: Function,
      required: true
    },
    value: {
      required: true
    }
  },
  data () {
    return {
      region: null,
      regions: [],
      department: null,
      departments: [],
      employmentZone: null,
      employmentZones: []
    }
  },
  mounted () {
    this.geoApi.post('/crud/region', {
      filters: [
        {
          type: 'App\\Model\\Filter\\NotFilter',
          filter: { type: 'App\\Model\\Filter\\LikeFilter', field: 'code', value: '"0%"' }
        }
      ],
      limit: 100,
      orders: [
        { column: 'name' }
      ]
    }).then(({data}) => {
      this.regions.splice(0, this.regions.length, ...data.results)
    })
    Promise.all(Array.from(Array(4).keys()).map(i => {
      return this.geoApi.post('/crud/employment_zone', {
        limit: 100,
        offset: i * 100,
        orders: [
          { column: 'name' }
        ]
      }).then(({data}) => data)
    })).then(data => {
      this.employmentZones.splice(0, this.employmentZones.length, ...[].concat(
        ...data.map(d => d.results)
      ))
    })
  },
  methods: {
    changeDepartment () {
      this.emit()
    },
    changeRegion () {
      this.department = null
      if (this.region === null) {
        this.departments.splice(0)
      } else {
        this.employmentZone = null
        this.geoApi.post('/crud/department', {
          filters: [
            { type: 'App\\Model\\Filter\\EqualsFilter', field: 'region', value: `${this.region.id}` }
          ],
          limit: 100,
          orders: [
            { column: 'name' }
          ]
        }).then(({data}) => {
          this.departments.splice(0, this.departments.length, ...data.results)
        })
      }
      this.emit()
    },
    changeEmploymentZone () {
      if (this.employmentZone !== null) {
        this.region = null
      }
      this.emit()
    },
    emit () {
      this.$emit('input', this.getSelectedLocation())
    },
    getSelectedLocation () {
      if (this.employmentZone !== null) {
        return this.employmentZone
      }
      if (this.region !== null) {
        return this.department !== null ? this.department : this.region
      }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/graphs/GeoSelector.vue